import axios from "../../axios";

import history from "../../history";

import moment from "../../moment";

import * as apis from "../../apis";
import * as errors from "../../errors";
import * as successes from "../../successes";
import * as infos from "../../infos";
import * as constants from "../../constants";

import {notifyError, notifyInfo, notifySuccess} from "../../toast-notifications";

import {changeFormField, getMinCakeDateTime} from "../../helpers";

import {resetShifts} from "./settings";
import {goToStep, SHIFT_STEP, SEATS_STEP} from "./ui";


export const RESERVATION_DOES_NOT_EXIST_ERROR = "RESERVATION_DOES_NOT_EXIST_ERROR"
export const RESERVATION_IS_PASSED = "RESERVATION_IS_PASSED"
export const SHIFT_NOT_AVAILABLE_ERROR = "SHIFT_NOT_AVAILABLE_ERROR"

export const getInitReservationForm = () => {
    return {
        first_name: {value: "", modified: false, type: "name", valid: false},
        last_name: {value: "", modified: false, type: "name", valid: false},
        adults: {value: 0, modified: false, type: "adults", valid: false},
        children: {value: 0, modified: false, type: "children", valid: true},
        start_time_date: {value: "", modified: false, type: "date", valid: false},
        start_time_time: {value: "", modified: false, type: "time", valid: false},
        event: {value: constants.eventTypes[0].value, modified: false, type: "event", valid: true},
        custom_event: {value: null, modified: false, type: "custom_event", valid: true},
        comment : {value: "", modified: false, type: "comment", valid: true},
        cake: {value: false, modified: false, type: "boolean", valid: true},
        stroller: {value: false, modified: false, type: "boolean", valid: true},
        highchair: {value: false, modified: false, type: "boolean", valid: true},
        reduced_mobility: {value: false, modified: false, type: "boolean", valid: true},
        terrace: {value: false, modified: false, type: "boolean", valid: true},
        phone: {value: "", modified: false, type: "phone", valid: false},
        email: {value: "", modified: false, type: "email", valid: false},
        accept_adds: {value: false, modified: false, type: "boolean", valid: true},
        gdpr: {value: false, modified: false, type: "gdpr", valid: false},
    }
};

// export const getInitReservationForm = () => {
//     return {
//         first_name: {value: "Baptiste", modified: false, type: "name", valid: false},
//         last_name: {value: "Hanssens", modified: false, type: "name", valid: false},
//         adults: {value: 2, modified: false, type: "adults", valid: false},
//         children: {value: 0, modified: false, type: "children", valid: true},
//         start_time_date: {value: "2020-04-22", modified: false, type: "date", valid: false},
//         start_time_time: {value: "20:00", modified: false, type: "time", valid: false},
//         event: {value: constants.eventTypes[0].value, modified: false, type: "event", valid: true},
//         comment : {value: "Hey, just wanna know something", modified: false, type: "comment", valid: true},
//         cake: {value: true, modified: false, type: "boolean", valid: true},
//         stroller: {value: true, modified: false, type: "boolean", valid: true},
//         highchair: {value: true, modified: false, type: "boolean", valid: true},
//         reduced_mobility: {value: true, modified: false, type: "boolean", valid: true},
//         terrace: {value: true, modified: false, type: "boolean", valid: true},
//         phone: {value: "+32472556997", modified: false, type: "phone", valid: false},
//         email: {value: "hanssens.baptiste@gmail.com", modified: false, type: "email", valid: false},
//         accept_adds: {value: true, modified: false, type: "boolean", valid: true},
//         gdpr: {value: true, modified: false, type: "gdpr", valid: false},
//     }
// };

export const formToReservation = (form) => {
    return {
        first_name: form.first_name.value,
        last_name: form.last_name.value,
        start_time: form.start_time_date.value + " " + form.start_time_time.value, //moment(form.start_time_date.value + " " + form.start_time_time.value, "YYYY-MM-DD HH:mm").format(),
        adults: form.adults.value,
        children: form.children.value,
        cake: form.cake.value,
        highchair: form.highchair.value,
        reduced_mobility: form.reduced_mobility.value,
        terrace: form.terrace.value,
        stroller: form.stroller.value,
        comment: form.comment.value,
        event: form.event.value,
        custom_event: form.custom_event.value,
        customer: {
            first_name: form.first_name.value,
            last_name: form.last_name.value,
            email: form.email.value,
            phone: form.phone.value,
            accept_adds: form.accept_adds.value,
        }
    };
}

export const CHANGE_FORM = "CHANGE_FORM";
export const RESET_FORM = "RESET_FORM";

export const changeForm = (e, { name, value, checked }) => {
    return (dispatch, getState) => {
        const currentForm = getState().reservationReducer.form;

        if (["accept_adds", "cake", "stroller", "highchair", "reduced_mobility", "terrace", "gdpr"].includes(name)) {
            value = checked;
        }

        let newForm = changeFormField(currentForm, name, value);

        // Switch cake to false if date or time changed
        if (["start_time_time", "start_time_date"].includes(name)) {
            const cake_before_duration = getState().settingsReducer.restaurantSettings.cake_before_duration;
            const reservationMoment = moment(currentForm.start_time_date.value + " " + currentForm.start_time_time.value);
            if (reservationMoment.isBefore(getMinCakeDateTime(cake_before_duration))) {
                newForm = changeFormField(newForm, "cake", false);
            }
        }

        // Reset date and time if adults or children changed
        if (["adults", "children"].includes(name) && currentForm.start_time_time.value && currentForm.start_time_date.value){
            dispatch(resetShifts(true));
            newForm = changeFormField(newForm, "start_time_time", "");
            newForm = changeFormField(newForm, "start_time_date", "");
        }

        dispatch({type: CHANGE_FORM, form: newForm});
    }
};

// GET CURRENT RESERVATION
export const GET_CURRENT_RESERVATION_REQUEST = "GET_CURRENT_RESERVATION_REQUEST";
export const GET_CURRENT_RESERVATION_SUCCESS = "GET_CURRENT_RESERVATION_SUCCESS";
export const GET_CURRENT_RESERVATION_ERROR = "GET_CURRENT_RESERVATION_ERROR";

export const getCurrentReservationRequest = () => {
    return {
        type: GET_CURRENT_RESERVATION_REQUEST,
        loading: true
    };
};
export const getCurrentReservationSuccess = (reservation) => {
    return {
        type: GET_CURRENT_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservation
    };
};
export const getCurrentReservationError = (error) => {
    return {
        type: GET_CURRENT_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const getCurrentReservation = (last_name, token) => {
    return dispatch => {
        dispatch(getCurrentReservationRequest());
        const data = {
            last_name: last_name,
            token: token
        }
        axios.post(apis.GET_CURRENT_RESERVATION_API, data)
            .then(response => {
                dispatch(getCurrentReservationSuccess(response.data));
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.data.message === RESERVATION_DOES_NOT_EXIST_ERROR) {
                        dispatch(getCurrentReservationError(RESERVATION_DOES_NOT_EXIST_ERROR));
                    }
                    else if (error.response.data.message === RESERVATION_IS_PASSED){
                        dispatch(getCurrentReservationError(RESERVATION_IS_PASSED));
                    }
                    else {
                        dispatch(getCurrentReservationError(errors.GET_CURRENT_RESERVATION_ERROR));
                        notifyError(errors.GET_CURRENT_RESERVATION_ERROR);
                    }
                }
                else {
                    dispatch(getCurrentReservationError(errors.GET_CURRENT_RESERVATION_ERROR));
                    notifyError(errors.GET_CURRENT_RESERVATION_ERROR);
                }
            });
    };
};

// CONFIRM RESERVATION
export const CONFIRM_RESERVATION_REQUEST = "CONFIRM_RESERVATION_REQUEST";
export const CONFIRM_RESERVATION_SUCCESS = "CONFIRM_RESERVATION_SUCCESS";
export const CONFIRM_RESERVATION_ERROR = "CONFIRM_RESERVATION_ERROR";

export const confirmReservationRequest = () => {
    return {
        type: CONFIRM_RESERVATION_REQUEST,
        loading: true
    };
};
export const confirmReservationSuccess = () => {
    return {
        type: CONFIRM_RESERVATION_SUCCESS,
        loading: false,
        error: null,
    };
};
export const confirmReservationError = (error) => {
    return {
        type: CONFIRM_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const confirmReservation = (reservation) => {
    return (dispatch, getState) => {
        dispatch(confirmReservationRequest());
        const reservation = formToReservation(getState().reservationReducer.form)
        axios.post(apis.CONFIRM_RESERVATION_API, reservation)
            .then(response => {
                dispatch(confirmReservationSuccess());
                notifySuccess(successes.CONFIRM_RESERVATION_SUCCESS)
                const lastName = response.data.last_name
                const token = response.data.token
                dispatch({type: RESET_FORM});
                dispatch(goToStep(SEATS_STEP));
                history.push("/summary?last_name=" + lastName + "&token=" + token);
            })
            .catch(error => {
                if (error.response.data) {
                    const message = error.response.data.message
                    if (message === "SHIFT_NOT_AVAILABLE_ERROR") {
                        dispatch(changeForm(null, {name: "start_time_time", value: ""}))
                        dispatch(changeForm(null, {name: "start_time_date", value: ""}))
                        dispatch(resetShifts());
                        dispatch(goToStep(SHIFT_STEP));
                        dispatch(confirmReservationError(infos.CHECK_AVAILABILITY_FAILED_INFO));
                        notifyInfo(infos.CHECK_AVAILABILITY_FAILED_INFO)
                    }
                }
                else {
                    dispatch(confirmReservationError(errors.CONFIRM_RESERVATION_ERROR));
                    notifyError(errors.CONFIRM_RESERVATION_ERROR);
                }
            });
    };
};

// CANCEL RESERVATION
export const CANCEL_RESERVATION_REQUEST = "CANCEL_RESERVATION_REQUEST";
export const CANCEL_RESERVATION_SUCCESS = "CANCEL_RESERVATION_SUCCESS";
export const CANCEL_RESERVATION_ERROR = "CANCEL_RESERVATION_ERROR";

export const cancelReservationRequest = () => {
    return {
        type: CANCEL_RESERVATION_REQUEST,
        loading: true
    };
};
export const cancelReservationSuccess = () => {
    return {
        type: CANCEL_RESERVATION_SUCCESS,
        loading: false,
        error: null
    };
};
export const cancelReservationError = (error) => {
    return {
        type: CANCEL_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const cancelReservation = (customer_cancel_message = undefined) => {
    return (dispatch, getState) => {
        dispatch(cancelReservationRequest());
        const currentReservation = getState().reservationReducer.currentReservation;
        const data = {
            last_name: currentReservation.last_name,
            token: currentReservation.token,
            customer_cancel_message,
        };

        axios.post(apis.CANCEL_RESERVATION_API, data)
            .then(response => {
                dispatch(cancelReservationSuccess());
                dispatch(getCurrentReservation(currentReservation.last_name, currentReservation.token))
                notifySuccess(successes.CANCEL_RESERVATION_SUCCESS)
            })
            .catch(error => {
                dispatch(cancelReservationError(errors.CANCEL_RESERVATION_ERROR));
                notifyError(errors.CANCEL_RESERVATION_ERROR);
            });
    };
};

// CONTACT RESTAURANT
export const CONTACT_RESTAURANT_REQUEST = "CONTACT_RESTAURANT_REQUEST";
export const CONTACT_RESTAURANT_SUCCESS = "CONTACT_RESTAURANT_SUCCESS";
export const CONTACT_RESTAURANT_ERROR = "CONTACT_RESTAURANT_ERROR";

export const contactRestaurantRequest = () => {
    return {
        type: CONTACT_RESTAURANT_REQUEST,
        loading: true
    };
};
export const contactRestaurantSuccess = () => {
    return {
        type: CONTACT_RESTAURANT_SUCCESS,
        loading: false,
        error: null
    };
};
export const contactRestaurantError = (error) => {
    return {
        type: CONTACT_RESTAURANT_ERROR,
        loading: false,
        error
    };
};
export const contactRestaurant = (message) => {
    return (dispatch, getState) => {
        dispatch(contactRestaurantRequest());
        const currentReservation = getState().reservationReducer.currentReservation;
        const data = {
            last_name: currentReservation.last_name,
            token: currentReservation.token,
            message: message
        }
        axios.post(apis.CONTACT_RESTAURANT_API, data)
            .then(response => {
                dispatch(contactRestaurantSuccess());
                notifySuccess(successes.CONTACT_RESTAURANT_SUCCESS)
            })
            .catch(error => {
                dispatch(contactRestaurantError(errors.CONTACT_RESTAURANT_ERROR));
                notifyError(errors.CONTACT_RESTAURANT_ERROR);
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/reservation.js